// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__1Dz_3","logo":"footer_logo__2prJS","text":"footer_text__3PEwD","cta":"footer_cta__2JLOe","links":"footer_links__GpTV-","link":"footer_link__2btRi"};